import React from 'react'
import { connect } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import { fetchWpPostById, fetchLatestWpPosts } from '../../actions/learn.js'

import { UilCalendar, UilClockThree, UilAngleLeft, UilAngleRight, UilAngleDoubleLeft, UilAngleDoubleRight } from '@iconscout/react-unicons'

import imgHero from '../../images/hero-learn.png'
import imgSectionOne from '../../images/img_technical_01.png'
import imgLatest1 from '../../images/latest-img-1.jpg'
import imgLatest2 from '../../images/latest-img-2.jpg'
import imgLatest3 from '../../images/latest-img-3.jpg'

import { translate } from '../../helpers/global.js'

class LearnDetail extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
		
		// Get post ID from URL parameters
		const postId = this.props.match.params.postId
		if (postId) {
			this.props.dispatch(fetchWpPostById(postId))
      .then(() => {
        this.props.history.replace(`/learn-detail/${this.props.wpPostDetail.get('slug')}`, { preventRefresh: true })
      })
		}
		
		// Fetch latest posts for sidebar if not already loaded
		if (!this.props.latestWpPosts || this.props.latestWpPosts.size === 0) {
			this.props.dispatch(fetchLatestWpPosts())
		}
	}

	componentDidUpdate(prevProps) {
		// If URL parameter changes, fetch new post
		const prevPostId = prevProps.match.params.postId
		const currentPostId = this.props.match.params.postId
		
		if (prevPostId !== currentPostId && currentPostId) {
			this.props.dispatch(fetchWpPostById(currentPostId))
      .then(() => {
        this.props.history.replace(`/learn-detail/${this.props.wpPostDetail.get('slug')}`, { preventRefresh: true })
      })
		}
	}

	formatDate = (dateString) => {
		const date = new Date(dateString)
		const options = { year: 'numeric', month: 'short', day: 'numeric' }
		return date.toLocaleDateString('en-US', options)
	}

	decodeHtmlEntities = (text) => {
		if (!text) return text
		const textArea = document.createElement('textarea')
		textArea.innerHTML = text
		return textArea.value
	}

	renderLatestBlogs = () => {
		const { latestWpPosts } = this.props
		
		if (!latestWpPosts || latestWpPosts.size === 0) {
			return <div>Loading latest posts...</div>
		}

		return latestWpPosts.slice(0, 3).map((blog, index) => (
			<RouterLink 
				key={index} 
				to={`/learn-detail/${blog.get('id')}`} 
				className="latest-blog"
				style={{textDecoration: 'none', color: 'inherit'}}
			>
				<div className="latest-img">
					<img src={blog.get('thumbnail') || imgLatest1} alt={blog.get('title')} />
				</div>
				<div className="latest-text">
					<h5>{blog.get('title')}</h5>
					<label>{blog.get('categories') && blog.get('categories').size > 0 ? this.decodeHtmlEntities(blog.get('categories').get(0)) : 'Article'}</label>
					<p className="blog-card-desc">"{blog.get('short_description')}"</p>
					<p className="hero-blog-desc">
						<span><UilCalendar size="18" />{this.formatDate(blog.get('date'))}</span>
						<span><UilClockThree size="18" />{blog.get('read_duration')}</span>
					</p>
				</div>
			</RouterLink>
		))
	}

  renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } })

  render() {
    const { globalGetLanguages, wpPostDetail, wpPostDetailError } = this.props
    
    // Extract tag names for easy access - handle both regular array and Immutable List
    const rawTagNames = wpPostDetail ? wpPostDetail.get('tag_names') : null
    const tagNames = rawTagNames ? (Array.isArray(rawTagNames) ? rawTagNames : rawTagNames.toJS ? rawTagNames.toJS() : []) : []
    
    // Function to check if current post is a comparison post
    const isComparisonPost = () => {
      return tagNames.some(tag => tag.toLowerCase().replace(/\s+/g, '-') === 'comparison')
    }
    
    const heroTitleClass = `hero-blog-title ${isComparisonPost() ? 'comparison' : ''}`.trim()
    
    // Show loading state while fetching post data
    if (!wpPostDetail) {
      return (
        <div id="homepage">
          <HeaderNewClear isOnStatusFor="is-on" />
          <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
            <section className='position-relative'>
              <div className="ban-text learn-detail">
                <div className="row">
                  <div className="col-md-8">
                    <div>Loading post...</div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <FooterNew />
        </div>
      )
    }

    // Show error state if post fetch failed
    if (wpPostDetailError) {
      return (
        <div id="homepage">
          <HeaderNewClear isOnStatusFor="is-on" />
          <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
            <section className='position-relative'>
              <div className="ban-text learn-detail">
                <div className="row">
                  <div className="col-md-8">
                    <div>Error loading post: {wpPostDetailError}</div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <FooterNew />
        </div>
      )
    }
    
    return (
      <div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />

        <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='position-relative'>
            <div className="ban-text learn-detail">
              {wpPostDetail.getIn(['_embedded', 'wp:featuredmedia', 0, 'source_url']) && (
                <img className="hero-blog-img" src={wpPostDetail.getIn(['_embedded', 'wp:featuredmedia', 0, 'source_url'])} alt="Hero" />
              )}
              <div className={`row ${isComparisonPost() ? 'comparison' : ''}`}>
                <div className={`${isComparisonPost() ? 'col-md-8' : 'col-md-8'}`}>
                  <h2 className={heroTitleClass}>
                    {this.renderHTML(wpPostDetail.getIn(['title', 'rendered']))}
                  </h2>
                  <p className={`hero-blog-desc ${isComparisonPost() ? 'hide' : ''}`}>
                    <span><UilCalendar size="18" />{this.formatDate(wpPostDetail.get('date'))}</span>
                    <span><UilClockThree size="18" />{wpPostDetail.get('read_duration') || '5 min read'}</span>
                  </p>
                  {wpPostDetail.getIn(['_embedded', 'author', 0, 'name']) && (
                    <p className="hero-blog-author hide">
                      <span>Author: <b>{wpPostDetail.getIn(['_embedded', 'author', 0, 'name'])}</b></span>
                      {wpPostDetail.getIn(['_embedded', 'author', 0, 'name']) && (
                        <>
                          <span className="separator">|</span>
                          <span>Editor: <b>{wpPostDetail.getIn(['_embedded', 'author', 0, 'name'])}</b></span>
                        </>
                      )}
                    </p>
                  )}

                  <div className="blog-html-content m-t-32">
                    {this.renderHTML(wpPostDetail.getIn(['content', 'rendered']))}
                  </div>

                </div>
                <div className={`col-md-4 latest-container`}>
                  <h5>Latest</h5>
                  <div className="latest-list">
                    {this.renderLatestBlogs()}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  globalGetLanguages: state.globalGetLanguages,
  wpPostDetail: state.wpPostDetail,
  wpPostDetailError: state.wpPostDetailError,
  latestWpPosts: state.latestWpPosts
})

export default connect(mapStateToProps)(LearnDetail)
